import { SET_PRODUCT_LIST_TOTAL, SET_PAGE_LIMIT } from "../action-types/plp";

const initialState = {
  productListTotal: 0,
  pageLimit: 0,
};

const productListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PRODUCT_LIST_TOTAL:
      return { ...state, productListTotal: action.payload };

    case SET_PAGE_LIMIT:
      return { ...state, pageLimit: action.payload };

    default:
      return state;
  }
};

export default productListReducer;